import { render, staticRenderFns } from "./New-Layout.vue?vue&type=template&id=fd21b9bc"
import script from "./New-Layout.vue?vue&type=script&lang=js"
export * from "./New-Layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports